interface sectionScrollPageConfig {
  headerOffset?: number;
  linkSelector?: string;
  sectionSelector?: string;
}

const sectionScrollPage = {
  init(config: sectionScrollPageConfig = {}) {
    const headerOffset = config.headerOffset ?? 80;
    const linkSelector = config.linkSelector ?? '.saig-o-section__scroll-page__sidebar__sidebar-link';
    const sectionSelector = config.sectionSelector ?? '.saig-o-section__scroll-page_main-content_content-section';

    const links: NodeListOf<HTMLButtonElement> = document.querySelectorAll(linkSelector);
    const sections: HTMLElement[] = Array.from(document.querySelectorAll(sectionSelector));

    if (!links.length || !sections.length) {
      return;
    }

    // --- Smooth Scroll on Click ---
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('data-target');
        const target = document.getElementById(targetId!);
        if (!target) return;

        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });

        setActiveLink(link);
      });
    });
    const nav = document.querySelector('.nav-sticky') as HTMLElement | null;
    const container = nav?.closest('.saig-o-section__scroll-page__sidebar') as HTMLElement | null;

    if (!nav || !container) {
      console.warn('scrollpage: .nav-sticky or .left-panel not found');
      return;
    }

    const topOffset = 100; // adjust if you have a fixed header
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('id');
          if (!id) return;

          const link = document.querySelector(`${linkSelector}[data-target="${id}"]`) as HTMLElement;
          if (!link) return;

          if (entry.isIntersecting) {
            setActiveLink(link);
          }
        });
      },
      {
        rootMargin: `-${headerOffset + 10}px 0px -60% 0px`,
        threshold: 0.1,
      }
    );

    sections.forEach((section) => observer.observe(section));

    function setActiveLink(activeLink: HTMLElement) {
      links.forEach((l) => l.classList.remove('active'));
      activeLink.classList.add('active');
    }
  },
};
sectionScrollPage.init({ headerOffset: 100 });
export default sectionScrollPage;
